<template>
  <div>
    <CardShadow>
      <div class="px-3">
        <div class="row align-items-center">
          <div class="col-12 col-lg-2 py-2" style="font-size:12px">
            <a href="#" @click.prevent="goBack()"><b>VOLVER</b></a>
          </div>
          <div class="col-6 col-lg-5" style="font-size:12px">
            <span>{{ stadiumName }}</span><br>
            <span>
              <b>
                {{ ticketPrint.participant.ticketTypeName }}
                <span v-if="ticketPrint.participant.seat">
                  | Asiento: {{ ticketPrint.participant.seat }}
                </span>
              </b>
            </span>
          </div>
          <div class="col-6 col-lg-5 px-0">
            <CardLogoVs
              class="card-logo-dark"
              logoVs="/images/logo-vs.png"
              :nameVs="versus.smallSecond"
              :date="dateEvent"
              :hour="dateHourEvent"
            />
          </div>
        </div>
      </div>
    </CardShadow>
    <div class="mb-3">
      <button
        @click="print()"
        type="button"
        name="button"
        class="btn btn-sm btn-secondary py-2 my-1"
      >
        Imprimir o descargar entrada
      </button>
      <button
        @click="modalConfirm = true"
        v-if="ticketPrint.participant.email"
        type="button"
        class="btn btn-sm btn-secondary py-2 ml-0 ml-sm-3 my-1"
      >
        Enviar entrada al email del asistente
      </button>
    </div>
    <CardShadow>
      <div class="p-3 pl-5">
        <h4 class="mt-3 mb-0 text-danger">
          <b>IMPRIMIR ESTA HOJA ES OBLIGATORIO</b>
        </h4>
        <h6 class="mt-3 mb-0">
          <b>ES OBLIGATORIO IMPRIMIRLA PARA PODER INGRESAR AL ESTADIO</b>
        </h6>
        <div class="position-relative">
          <div style="overflow-x: scroll;">
            <TicketFutbol :item="ticketPrint.participant" />
          </div>
          <p class="text-orientation"><b>ANVERSO</b></p>
        </div>
        <hr>
        <div class="position-relative">
          <TicketText/>
          <p class="text-orientation"><b>REVERSO</b></p>
        </div>
      </div>
    </CardShadow>
    <CardShadow>
      <div class="text-center">
        <img src="/images/mapa.jpg" alt="mapa" class="img-fluid">
      </div>
    </CardShadow>
    <b-modal v-model="modalConfirm" hide-header hide-footer size="md" centered>
      <div class="d-block p-5">
        <h4>¿Estás seguro de enviar la entrada al asistente?</h4>
        <hr>
        <h5>
          Una copia de esta entrada se enviará a: <br>
          <b>{{ ticketPrint.participant.email }}</b>
        </h5>
        <p v-if="sendOk" class="text-success">
          La entrada se envió correctamente.
        </p>
      </div>
      <a href="#" @click.prevent="modalConfirm = false" class="btn-close-modal">
        <i class="fa fa-times text-dark"></i>
      </a>
      <button type="button" :disabled="loading" @click="sendMailPdf()"
        class="btn px-5 btn-primary btn-submit-modal rounded-0">
        CONFIRMAR Y ENVIAR
      </button>
    </b-modal>
  </div>
</template>
<script>
import api from '../api';

export default {
  props: ['ticketPrint'],
  data() {
    return {
      loading: false,
      modalConfirm: false,
      sendOk: false,
    };
  },
  methods: {
    goBack() {
      this.$emit('onGoBack');
    },
    print() {
      window.print();
    },
    sendMailPdf() {
      const { participant } = this.ticketPrint;
      const payload = {
        data: [participant],
        email: participant.email,
      };
      this.sendTicketsPdf(payload);
    },
    async sendTicketsPdf(payload) {
      this.loading = true;
      const url = '/code-exchange/send-email-tickets';
      const { data: res } = await api.axios.post(url, { payload });
      // this.loading = false;
      if (res.success) {
        this.sendOk = true;
        setTimeout(() => {
          this.sendOk = false;
          this.modalConfirm = false;
        }, 5000);
      }
    },
  },
};
</script>
